import * as React from "react";
import ReportStatus from "../model/report/ReportStatus";
import ReportStatusUtils from "../../reports/ReportStatusUtils";

interface StatusViewerProps {
  status: ReportStatus;
  className?: string;
  detail?: string;
}

// LongTermFix 18/02/2020 aledref: should be refactored with StatusViewer to take into props style, icon an i18n key direclty
export default function StatusViewer(props: StatusViewerProps) {
  return (
    <div
      className={`status-viewer ${ReportStatusUtils.getStatusTypeStyle(
        props.status
      )}${props.className ? " " + props.className : ""}`}
    >
      <i className={ReportStatusUtils.getStatusIcon(props.status)} />
      <span>
        {i18n[ReportStatusUtils.getStatusTypeI18nKey(props.status)]}
        {props.detail &&
          `: ${
            ReportStatusUtils.getRejectionCauseI18nKey(props.detail)
              ? i18n[ReportStatusUtils.getRejectionCauseI18nKey(props.detail)]
              : props.detail
          }`}
      </span>
    </div>
  );
}
